import { render, staticRenderFns } from "./Neighborhood.vue?vue&type=template&id=79e9b738&scoped=true&"
import script from "./Neighborhood.vue?vue&type=script&lang=js&"
export * from "./Neighborhood.vue?vue&type=script&lang=js&"
import style0 from "./Neighborhood.vue?vue&type=style&index=0&id=79e9b738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e9b738",
  null
  
)

export default component.exports